var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var Svg20LogoTelegram = function Svg20LogoTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.774 9.588Q8.79 6.594 11.131 5.64c4.455-1.815 5.38-2.13 5.984-2.14.133-.003.43.029.622.182a.66.66 0 0 1 .228.425c.022.123.048.401.027.619-.241 2.484-1.286 8.514-1.817 11.296-.225 1.178-.671 1.43-1.1 1.468-.932.084-1.636-.46-2.539-1.04-1.412-.906-1.93-1.15-3.301-2.034-1.584-1.023-.72-1.558.183-2.476.236-.24 4.37-3.984 4.45-4.316.01-.041-.126-.456-.22-.538s-.233-.053-.332-.031q-.213.047-6.768 4.38-.96.646-1.74.63c-.573-.012-1.675-.317-2.494-.578-1.005-.32-1.375-.47-1.306-1.014q.054-.424.766-.886"
  })));
};
var Memo = /*#__PURE__*/memo(Svg20LogoTelegram);
export default Memo;